import ValidatableObject from "../validation/ValidatableObject";
import Model from "../Model";

export interface TReport6RiskCriteria {
  name: string;
  reportId: number;
}

export interface IReport6RiskCriteria extends TReport6RiskCriteria {}

const Report6RiskCriteria = Model(
  (model: TReport6RiskCriteria): TReport6RiskCriteria => {
    const _report6RiskCriteria: TReport6RiskCriteria = Object.assign({}, model);

    let create = (
      report6RiskCriteria: IReport6RiskCriteria
    ): IReport6RiskCriteria => {
      let obj = ValidatableObject(report6RiskCriteria);
      return obj;
    };

    let report6RiskCriteria = {
      get name() {
        return _report6RiskCriteria.name;
      },
      set name(value) {
        _report6RiskCriteria.name = value;
      },
      get reportId() {
        return _report6RiskCriteria.reportId;
      },
      set reportId(value) {
        _report6RiskCriteria.reportId = value;
      }
    };
    return create(report6RiskCriteria);
  }
);

export default Report6RiskCriteria;
